import * as R from 'ramda';
import config from 'utils/config';

const mbToken = config(['mapbox', 'accessToken']);
const styleSource = config(['mapbox', 'stylesSource']);

/**
 * Retrieves the src for a static Mapbox map image, using the Mapbox static
 * API. Mapbox expects lat/lng as lng/lat, so we flip them.
 * @param lngLat Coordinates array
 * @returns An image source URL from Mapbox.
 */
const getStaticMapImg: getStaticMapImgDef = (lngLat, zoom = 12) => R.tryCatch(
  R.pipe(
    R.reverse,
    R.join(','),
    val => `https://api.mapbox.com/styles/v1/${styleSource}/static/${val},${zoom},0.00,0.00/1000x1000@2x?access_token=${mbToken}`,
  ),
  R.always(''),
)(lngLat);

type getStaticMapImgDef = (lngLat: string|number[], zoom: number) => string;

export default getStaticMapImg;
